<template>
  <div class="notification-wrap">
    <div class="corner"></div>
    <div class="transparent-block"></div>
    <ul class="messages-list" v-if="allNotify.length">
      <li class="messages-list-item"
          v-for="(notify, index) in notifyArr">

        <div v-if="notify.type_id === 1" @click="markStatusAsRead(index)">
          <!--  убрать класс message-item-padding если в уведомлении НЕТ кнопок Отклонить и Принять-->
          <div class="message-item message-item-padding">
            <div class="icon">
              <img v-if="notify.source_user.contacts.avatar_url"
                   :src="notify.source_user.contacts.avatar_url" alt="">
              <user v-else :fill="'#109CF1'"></user>
            </div>
            <p class="message">
              <span>
                {{notify.source_user.first_name}} <span v-if="notify.source_user.second_name">{{notify.source_user.second_name}}</span>
              </span>
              {{$t('popups.notifications.assignedToRole')}}
              <span>
                {{notify.role.name}}
              </span>
            </p>
            <p class="days"
               :class="{'active': notify.activeFlag}">
              {{getTimeAgo(notify.created_at)}}
            </p>
          </div>
          <div class="btns-cont" v-if="true">
            <button type="button"
                    @click="reject(notify.role.id, notify.id)"
                    class="btn btn-transparent_blue">
              {{$t('btns.rejectRole')}}
            </button>
            <button type="button"
                    @click="confirm(notify.role.id, notify.id)"
                    class="btn btn-blue">
              {{$t('btns.acceptRole')}}
            </button>
          </div>
        </div>

        <div v-else @mouseover="markStatusAsRead(index)">
          <div class="message-item">
            <div class="icon">
              <img v-if="notify.source_user.contacts.avatar_url"
                   :src="notify.source_user.contacts.avatar_url" alt="">
              <user v-else :fill="'#109CF1'"></user>
            </div>
            <p class="message">
              <span>
                {{notify.source_user.first_name}} <span v-if="notify.source_user.second_name">{{notify.source_user.second_name}}</span>
              </span>
              {{whatHappened(notify)}}
              <span v-if="notify.role">
                {{notify.role.name}}
              </span>
              <span v-if="notify.project">
                {{notify.project.name}}
              </span>
              <span v-if="notify.device">
                {{notify.device.name}}
              </span>
            </p>
            <p class="days"
               :class="{'active': notify.activeFlag}">
              {{getTimeAgo(notify.created_at)}}
            </p>
          </div>
        </div>

      </li>

    </ul>
    <!--    если нет уведомлений-->
    <ul class="messages-list" v-else>
      <li class="message-item">
        <div class="message">
          {{$t('labels.noNotifications')}}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import user from './../Svg/users/user'

import {mapState, mapActions} from 'vuex'
import {tokenAndRoute} from "../../mixins/utils/tokenAndRoute";

export default {
  name: 'notificationsList',
  mixins: [tokenAndRoute],
  components: {user},
  data() {
    return {
      loading: false,
      // activeClass: true,
      allNotifyWithActiveFlag: []
    }
  },
  props: {
    allNotify: Array,
    appFlag: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      // invites: state => state.roles.invites
      // allNotify: state => state.roles.allNotify
    }),
    notifyArr() {
      return this.allNotifyWithActiveFlag
    }
  },
  methods: {
    ...mapActions({
      confirmInvite: 'roles/confirmInvite',
      rejectInvite: 'roles/rejectInvite',
      getAllNotify: 'roles/getAllNotify',
      readInvite: 'roles/readInvite',
      loadAssignedRoles: 'roles/getAssignedRoles',
      loadUser: 'auth/loadUser',
    }),
    whatHappened(singleNotify) {
      //0 => "Remove role assignment"
      //1 => "Role assignment",
      //2 => "New permission for project",
      //3 => "New permission for project item",
      //4 => "New permission for device",
      //5 => "New permission for device property",
      //6 => "Update permission for project",
      //7 => "Update permission for project item",
      //8 => "Update permission for device",
      //9 => "Update permission for device property",
      //10 => "Delete permission for project",
      //11 => "Delete permission for project item",
      //12 => "Delete permission for device",
      //13 => "Delete permission for device property"
      if (singleNotify.type_id === 0) {
        this.loadUser()
        return this.$t('popups.notifications.removeRoleAssignment') //снял назначение на роль:
      }
      if (singleNotify.type_id === 2) {
        return this.$t('popups.notifications.assignedAsOwnerForProject') //назначил владельцем на проект:
      }
      if (singleNotify.type_id === 3) {
        return this.$t('popups.notifications.assignedAsOwnerForSection')  //на узел
      }
      if (singleNotify.type_id === 4) {
        return this.$t('popups.notifications.assignedAsOwnerForThing')  //на вещь
      }
      if (singleNotify.type_id === 5) {
        return 'назначил свойство ?? вещи:'
      }
      if (singleNotify.type_id === 6) {
        return 'изменил права на проект:'
      }
      if (singleNotify.type_id === 7) {
        return 'изменил права на узел:'
      }
      if (singleNotify.type_id === 8) {
        return 'изменил права на вещь:'
      }
      if (singleNotify.type_id === 9) {
        return 'изменил права на свойство?? вещи:'
      }
      if (singleNotify.type_id === 10) {
        return this.$t('popups.notifications.removeAccessToProject') //удалил доступ к проекту:
      }
      if (singleNotify.type_id === 11) {
        return this.$t('popups.notifications.removeAccessToSection') //к узлу
      }
      if (singleNotify.type_id === 12) {
        return this.$t('popups.notifications.removeAccessToThing') //к вещи
      }
      if (singleNotify.type_id === 13) {
        return 'удалил доступ к свойству вещи:'
      }
    },
    addAllNotifyActiveFlag() {
      let arr = [...this.allNotify]
      arr.forEach(item => {
        item.activeFlag = true
      })
      this.allNotifyWithActiveFlag = arr
    },
    getTimeAgo(seconds) {
      const NowMS = Date.now() / 1000
      let ago = Math.floor(NowMS - seconds) //время в секундах
      let days = 0
      let dayName = ''

      if (ago < 2592000) {
        //если меньше дня => сегодня
        if (ago < 86400) {
          dayName = `${this.$t('popups.notifications.daysAgo.today')}`
        }
        //если меньше месяца => количество дней
        while (ago >= 86400) { ago -= 86400; days += 1; }
        if (days === 1) {
          dayName = `${days} ${this.$t('popups.notifications.daysAgo.day1')}`
        }
        if (days === 2 || days === 3 || days === 4) {
          dayName = `${days} ${this.$t('popups.notifications.daysAgo.day2')}`
        }
        if (days > 4 && days < 21) {
          dayName = `${days} ${this.$t('popups.notifications.daysAgo.day3')}`
        }
        if (days === 21) {
          dayName = `${days} ${this.$t('popups.notifications.daysAgo.day1')}`
        }
        if (days === 22 || days === 23 || days === 24) {
          dayName = `${days} ${this.$t('popups.notifications.daysAgo.day2')}`
        }
        if (days > 24 && days < 31) {
          dayName = `${days} ${this.$t('popups.notifications.daysAgo.day3')}`
        }
      } else {
        dayName = `${this.$t('popups.notifications.daysAgo.moreThanMonth')}`
      }
      // console.log(dayName)
      return dayName
    },
    async reject(role_id, notify_id) {
      this.loading = true
      try {
        await this.rejectInvite({
          token: this.token,
          role_id
        })
        await this.readInvite({
          token: this.token,
          notify_id
        })
        this.$emit('readMessage', notify_id)
        await this.getAllNotify()
        await this.loadAssignedRoles(this.token)
        this.addAllNotifyActiveFlag()
      } catch (error) {
        console.log('Ошибка принятия роли', error)
      }
      this.loading = false
    },
    async confirm(role_id, notify_id) {
      this.loading = true
      try {
        await this.confirmInvite({
          token: this.token,
          role_id
        })
        await this.readInvite({
          token: this.token,
          notify_id
        })
        this.$emit('readMessage', notify_id)
        await this.getAllNotify()
        await this.loadAssignedRoles(this.token)
        this.addAllNotifyActiveFlag()
      } catch (error) {
        console.log('Ошибка принятия роли', error)
      }
      this.loading = false
    },
    markStatusAsRead(index) {
      let arr = [...this.allNotifyWithActiveFlag]
      if (this.default) {
        this.$emit('readMessage', arr[index].id)
      } else {
        arr[index].activeFlag = false
        this.allNotifyWithActiveFlag = arr
      }
    },
    async sendStatusToServer() {
      try {
        this.allNotifyWithActiveFlag.filter(async (item) => {
          if (!item.activeFlag) {
            await this.readInvite({
              token: this.token,
              notify_id: item.id
            })
          }
          await this.getAllNotify()
          await this.loadAssignedRoles(this.token)
        })
      } catch (error) {
        console.log('Ошибка доставки прочитанного статуса уведомлений', error)
      }
    }
  },
  mounted() {
    this.addAllNotifyActiveFlag()
  },
  destroyed() {
    if (this.appFlag === false) {
      this.sendStatusToServer()
    }
  }
}
</script>

<style lang="scss">
.notification-wrap {
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 82, 127, 0.2);
  z-index: 100;
}

.corner {
  position: absolute;
  right: 7px;
  top: 26px;
  width: 11px;
  height: 11px;
  transform: rotate(45deg);
  background-color: white;
  z-index: 1;
}

.transparent-block {
  position: absolute;
  right: -5px;
  top: 24px;
  width: 280px;
  height: 7px;
  background-color: transparent;
}

.messages-list {
  background: white;
  position: absolute;
  /*top: calc(100%);*/
  top: 32px;
  right: -10px;
  max-height: 400px;
  overflow-y: scroll;
  max-width: 290px;
  width: 290px;
  border-radius: 8px;
  text-align: left;
  box-shadow: 0 7px 8px rgba(0, 82, 127, 0.2);

  @include scrollbal(2px);

  .messages-list-item:not(:last-child) {
    border-bottom: 1px solid rgba(215, 227, 234, 0.2);
  }

  .message-item {
    display: flex;
    align-items: center;
    padding: 10px 6px;
    padding-right: 12px;
  }

  .message-item-padding {
    padding-right: 22px;
    padding-left: 16px;
  }

  .icon {
    width: 40px;
    height: 40px;
    min-width: 40px;
    min-height: 40px;
    border-radius: 50%;
    margin-right: 10px;
    background-color: #D7E3EA;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;


    img {
      height: 100%;
      width: auto;
    }

    svg {
      width: 70%;
    }
  }

  .message {
    font-family: $mr;
    font-size: 12px;
    letter-spacing: 0.15px;
    color: $darkBlue;
    line-height: 15px;
    margin-right: 5px;

    > span {
      font-family: $msb;
      color: $lightBlue;

    }
  }

  .days {
    font-family: $mm;
    font-size: 12px;
    letter-spacing: 0.25px;
    color: $grey;
    white-space: nowrap;
    align-self: flex-start;
    position: relative;
    padding-right: 3px;
    margin-left: auto;

    &.active {
      &::before {
        content: '';
        position: absolute;
        width: 4px;
        height: 4px;
        background: $red;
        border-radius: 50%;
        right: -6px;
        top: 7px;
      }
    }
  }

  .invite-item {
    flex-direction: column;
  }

  .btns-cont {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-top: 15px;
    margin-bottom: 15px;
    padding-right: 16px;
    padding-left: 16px;

    button {
      width: calc(50% - 8px);
      height: 34px;
    }
  }
}

</style>
